.prosecutor {
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  display: flex;
  gap: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-2) 0 var(--pgm-sys-spacing-4);
}

.image {
  border-radius: 4px;
  flex: 0 0 156px;
  height: 156px;
  object-fit: cover;
  width: 156px;
}

.about {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  min-width: 0;
}

.position {
  align-self: flex-start;
  border-radius: 4px;
  color: var(--pgm-sys-color-on-tertiary);
  padding: var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-2);
}

.positionGeneral {
  background-color: var(--pgm-sys-color-secondary);
  color: var(--pgm-sys-color-on-secondary);
}

.positionDeputy {
  background-color: var(--pgm-sys-color-tertiary);
  color: var(--pgm-sys-color-on-tertiary);
}

.infos {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
}

.name,
.bio {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.bioCollapsed {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}

.toggle {
  align-self: flex-start;
}

@media (max-width: 599.98px) {
  .prosecutor {
    flex-direction: column;
    gap: var(--pgm-sys-spacing-4);
  }

  .image {
    flex: 0 0 auto;
  }
}
